function initCheckboxGroup() {
    const checkboxGroup = document.querySelector('[data-checkbox-group]');
    if (!checkboxGroup) return;

    const checkboxes = checkboxGroup.querySelectorAll('input[type="checkbox"]');
    
    checkboxes.forEach((checkbox) => {
        const input = /** @type {HTMLInputElement} */ (checkbox);
        input.addEventListener('change', () => {
            if (input.checked) {
                checkboxes.forEach((otherCheckbox) => {
                    if (otherCheckbox !== checkbox) {
                        const otherInput = /** @type {HTMLInputElement} */ (otherCheckbox);
                        otherInput.checked = false;
                    }
                });
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initCheckboxGroup();
});